export default __webpack_public_path__ + "static/media/cage-length.4e76623f.svg";